import request from "@/plugins/axios"
//发票板式文件审核
let prefix = "eids-invoice/home"

export function kpi() {
  return request({
    url: prefix + '/kpi',
    method: 'get'
  })
}

export function daystat() {
  return request({
    url: prefix + '/daystat',
    method: 'get'
  })
}
